<template>
    <div class="row">
        <div class="col-xl-12">
            <h4 class="mt-0 mb-4">Change Password</h4>
            <change-password-form :loading="loading" :shouldClear="true" @submit="submitChangePassword"></change-password-form>
        </div>
    </div>
</template>
<script>
import ChangePasswordForm from 'Shared/Forms/ChangePasswordForm'
export default {
    components: {
        ChangePasswordForm
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        async submitChangePassword(values) {
            this.loading = true
            try {
                await this.$store.dispatch('auth/UPDATE_PASSWORD', values)
                this.$notify({
                    icon: 'nc-icon nc-check-2',
                    message: 'Your password was successfully changed.',
                    type: 'success',
                    horizontalAlign: 'center',
                    verticalAlign: 'bottom'
                })
            } catch (err) {
                this.$notify({
                    icon: 'nc-icon nc-simple-remove',
                    message: err.message,
                    type: 'danger',
                    horizontalAlign: 'center',
                    verticalAlign: 'bottom',
                    timeout: 0
                })
            } finally {
                this.loading = false
            }
        }
    }
}
</script>
